import { wealthProApi } from "../../redux/api";
import {
    buildEndpointUri,
    useCacheKeyMergeHandler,
    useCacheKeySerializeQueryArgsHandler,
    useCacheKeyTransformResponseHandler
} from "../../redux/helpers";

const graphSubscriptionApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ['graphSubscriptions']
}).injectEndpoints({
    endpoints: (builder => ({
        createSubscription: builder.mutation({
            query: (data: { userId: string, type: number }) => ({
                url: `api/graph/subscriptions`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['graphSubscriptions']
        }),
        deleteSubscription: builder.mutation({
            query: (subscriptionId: string) => ({
                url: `api/graph/subscriptions/${subscriptionId}`,
                method: 'DELETE',
                body: { }
            }),
            invalidatesTags: ['graphSubscriptions']
        }),
        fetchSubscriptions: builder.query({
            query: (args: PagedRequest) => buildEndpointUri(`api/graph/subscriptions`, args),
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: useCacheKeyMergeHandler,
            providesTags: ['graphSubscriptions']
        }),
        refreshSubscription: builder.mutation({
            query: (subscriptionId: string) => ({
                url: `api/graph/subscriptions/${subscriptionId}/refresh`,
                method: 'POST',
                body: { }
            }),
            invalidatesTags: ['graphSubscriptions']
        }),
        refreshAllSubscriptions: builder.mutation({
            query: () => ({
                url: `api/graph/subscriptions/mail/refresh`,
                method: 'POST',
                body: { }
            }),
            invalidatesTags: ['graphSubscriptions']
        })
    }))
});

export const {
    useCreateSubscriptionMutation,
    useDeleteSubscriptionMutation,
    useFetchSubscriptionsQuery,
    useLazyFetchSubscriptionsQuery,
    useRefreshSubscriptionMutation,
    useRefreshAllSubscriptionsMutation
} = graphSubscriptionApiEndpoints;